'use strict';

export default function directive($log, $parse, $timeout, pusher) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      channel: '@',
      event: '@',
      debounceMs: '@',
      maxDebounceMs: '@',
      onEvent: '&',
      context: '<',
    },
    link: link,
  };

  function link(scope) {
    const msDebounce = parseMs(scope.debounceMs, 1000);
    const msMax = parseMs(scope.maxDebounceMs, 5000);

    if (!scope.channel || !scope.event || !scope.onEvent) {
      $log.error('event-watcher: channel, event, and onEvent are required');
      return;
    }

    const state = {
      lastTriggerTime: null,
      debounceTimeout: null,
    }

    function triggerEvent() {
      state.lastTriggerTime = Date.now();
      $parse(scope.onEvent)(scope);
      $log.debug(`Triggered onEvent for ${scope.event} with channel ${scope.channel}`);
    }

    function handlePusherEvent() {
      $log.debug(`event-watcher: Received pusher event ${scope.event} for channel ${scope.channel}`);
      if (!state.lastTriggerTime) {
        triggerEvent();
        return;
      }
      if (state.debounceTimeout) {
        $timeout.cancel(state.debounceTimeout);
        state.debounceTimeout = null;
      }
      const now = Date.now();
      const timeSinceLastTrigger = now - state.lastTriggerTime;
      if (timeSinceLastTrigger >= msMax) {
        triggerEvent();
      } else {
        state.debounceTimeout = $timeout(() => {
          state.debounceTimeout = null;
          triggerEvent();
        }, msDebounce);
      }
    }

    const pusherChannel = pusher.subscribe(scope.channel);
    pusherChannel.bind(scope.event, handlePusherEvent);

    scope.$on('$destroy', () => {
      if (state.debounceTimeout) {
        $timeout.cancel(state.debounceTimeout);
      }
      pusherChannel.unbind(scope.event, handlePusherEvent);
    });
  }
}

function parseMs(value, defaultVal) {
  const n = Number.parseInt(value, 10);
  return Number.isFinite(n) && n >= 0 ? n : defaultVal;
}
